<template>
  <div class="profile-container text-center py-4">
    <div class="profile-wrapper">
      <div class="img-box shadow" :class="{ 'pulse-animation': isUploading }">
        <img :src="imgUrl" alt="profile image" @error="handleImageError" />
        <transition name="fade">
          <div v-if="isUploading" class="upload-overlay">
            <div class="loader-content">
              <div class="spinner-border text-light"></div>
              <span class="d-block text-white mt-2 small">Uploading...</span>
            </div>
          </div>
        </transition>

        <label
          for="upload"
          class="edit-btn shadow"
          :class="{ disabled: isUploading }"
        >
          <i class="fas fa-camera-solid fa-camera"></i>
        </label>
      </div>

      <input
        type="file"
        id="upload"
        @change="onFileChange"
        accept="image/*"
        hidden
        :disabled="isUploading"
      />

      <div class="user-meta mt-3">
        <h4>
          <span class="text-success">Welcome back,</span>
          <span>{{ username }}</span>
        </h4>
        <h6 class="mb-0 fw-bold text-dark">Profile Picture</h6>
        <p class="text-muted small">PNG, JPG up to 5MB</p>

        <!-- SUMMARY / CTA -->

        <dashboard-summary />
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2";
import DashboardSummary from "./dashboardSummary.vue";
export default {
  name: "Profile",
  components: {
    DashboardSummary,
  },
  data() {
    const userInfo = JSON.parse(localStorage.getItem("user"));
    return {
      imgUrl: require("../assets/task logo.png"),
      isUploading: false,
      username: userInfo.username,
    };
  },

  methods: {
    async onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (file.size > 5 * 1024 * 1024) {
        return Swal.fire(
          "Too large!",
          "Image size must be less than 5MB",
          "warning",
        );
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        this.imgUrl = e.target.result;
      };
      reader.readAsDataURL(file);

      this.handleFileUpload(file);
    },

    async handleFileUpload(file) {
      this.isUploading = true;
      const formData = new FormData();
      formData.append("profileImage", file);

      const userData = JSON.parse(localStorage.getItem("user"));
      formData.append("userId", userData?.id);

      try {
        const response = await axios.post(
          "https://app-dc37e42a-38d5-480d-9a3d-1349ea33f548.cleverapps.io/api/users/upload-profile",
          formData,
        );

        const newImageUrl = response.data.imageUrl;

       
        this.$store.commit("UPDATE_USER_PROFILE", newImageUrl);

       
        if (userData) {
          userData.profile_img = newImageUrl;
          localStorage.setItem("user", JSON.stringify(userData));
        }

        Swal.fire({
          icon: "success",
          title: "Updated!",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error:", error);
        Swal.fire("Error", "Upload failed", "error");
      } finally {
        this.isUploading = false;
      }
    },

    handleImageError() {
      this.imgUrl = require("../assets/task logo.png");
    },
  },

  computed: {
    // get current user from store
    currentUser() {
      return this.$store.state.user;
    },
    // get image url by default task logo.png
    imgUrl() {
      if (this.currentUser && this.currentUser.profile_img) {
        return this.currentUser.profile_img;
      }
      return require("../assets/task logo.png");
    },
    username() {
      return this.currentUser ? this.currentUser.username : "loading...";
    },
  },

  mounted() {
    if (!this.user) {
      this.$store.dispatch("getCurrentUser");
    }
  },
};
</script>
<style scoped lang="scss">
.img-box {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  position: relative;
  border-radius: 50%;
  border: 4px solid #fff;
  background: #fdfdfd;
  transition: all 0.3s ease;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  &.pulse-animation {
    animation: pulse 1.5s infinite;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.4);
  }
  70% {
    transform: scale(1.02);
    box-shadow: 0 0 0 10px rgba(13, 110, 253, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(13, 110, 253, 0);
  }
}

.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.edit-btn {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 36px;
  height: 36px;
  background: #198754;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 3;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  &:hover {
    background: #157347;
    transform: rotate(15deg) scale(1.1);
  }

  &.disabled {
    pointer-events: none;
    background: #6c757d;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
